import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Webgametechstack() {
  return (
    <section
      className="web_game_techstack p-100"
      style={{ background: "#f9f9f9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Technology Stack for <span>Web3 Game Development Solutions</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Like other mobile applications and cloud games, we create custom
              technology stacks for Web3 game development. And we have a set of
              best practices that we follow to establish these tech stacks.
              Firstly, our technology stacks follow the technical requirements
              and user preferences. Once we have the combination of suitable
              programming languages, software development kits, design tools,
              development frameworks, integrated environments, APIs and
              databases, we then check their sustainability for strong
              performance. With sustainable code, we also ensure our codes are
              scalable to future-proof the games.
            </p>
          </Col>
          <Row className="mt-3 mt-md-5">
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <div className="web_game_tech_main">
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../images/services-usa/web3-game/tech-stack/Binance_Smartchain.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={90}
                    />
                  </div>
                  <h5>Binance Smartchain</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../images/services-usa/web3-game/tech-stack/Firebase.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={90}
                    />
                  </div>
                  <h5>Firebase</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../images/services-usa/web3-game/tech-stack/JavaScript.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={90}
                    />
                  </div>
                  <h5>JavaScript</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../images/services-usa/web3-game/tech-stack/Meta_Mask.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={90}
                    />
                  </div>
                  <h5>Meta Mask</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../images/services-usa/web3-game/tech-stack/Polygon.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={90}
                    />
                  </div>
                  <h5>Polygon</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../images/services-usa/web3-game/tech-stack/Rust.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={90}
                    />
                  </div>
                  <h5>Rust</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../images/services-usa/web3-game/tech-stack/Solidity.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={90}
                    />
                  </div>
                  <h5>Solidity</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../images/services-usa/web3-game/tech-stack/Wallet_Connect.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={90}
                    />
                  </div>
                  <h5>Wallet Connect</h5>
                </div>
                <div className="web_game_tech_item">
                  <div className="web_game_tech_icon">
                    <StaticImage
                      src="../../images/services-usa/web3-game/tech-stack/Web3.webp"
                      alt="tekrevol_web"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={90}
                      height={90}
                    />
                  </div>
                  <h5>Web3</h5>
                </div>
              </div>
            </Col>
          </Row>
        </Row>
      </Container>
    </section>
  );
}

export default Webgametechstack;
